import React, { Component } from 'react'
import '../../styles/GlobalStyle.css'
import { db } from '../../firebase/Firebase'
import ColType from '../.././Types'
import { flattenDoc, getIDFromURL } from '../../Util'
//import { Layout, Icon, Button, Checkbox, Table } from 'antd'
import ChatHome from './ChatHome'

class TeacherChatHome extends Component {
    state = {
        teacherId: '',
        schoolPersonnelDict: {},
        retrievedTeachers: false,
    }

    // Do fetch here
    componentDidMount() {
        var teacherId = getIDFromURL(window.location)
        this.setState({
            teacherId: teacherId,
        })

        this.getTeachers()
    }

    componentWillReceiveProps(nextProps) {
        this.getTeachers()
    }

    getTeachers = () => {
        if (!(this.props.teacherBaseProps.teacher &&
            this.props.teacherBaseProps.school)) {
            return
        }
        if (this.state.retrievedTeachers) {
            return
        }
        this.setState({ retrievedTeachers: true })

        const school = this.props.teacherBaseProps.school

        // accumulate into a local — state is written once, on full success
        const localDict = {
            [school.id]: {
                'school': school, 'teachers': [], 'instructionalFacilitators': [], 'schoolAdmins': []
            }
        }
        const promises = []

        promises.push(
            db.collection(ColType.teacher)
                .where('schoolId', '==', school.id)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        localDict[school.id]['teachers'].push(flattenDoc(doc))
                    })
                })
        )

        promises.push(
            db.collection(ColType.instructionalFacilitator)
                .where('schoolIds', 'array-contains', school.id)
                .where('districtId', '==', school.districtId)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        localDict[school.id]['instructionalFacilitators'].push(flattenDoc(doc))
                    })
                })
        )

        promises.push(
            db.collection(ColType.schoolAdmin)
                .where('schoolId', '==', school.id)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        localDict[school.id]['schoolAdmins'].push(flattenDoc(doc))
                    })
                })
        )

        Promise.all(promises)
            .then(() => {
                this.setState({
                    schoolPersonnelDict: localDict,
                    personnelLoaded: true,
                })
            })
            .catch(() => {

            })
    }

    render() {
        return (
            <div>
                <ChatHome
                    personRole={'teacher'}
                    person={this.props.teacherBaseProps.teacher}
                    students={this.props.teacherBaseProps.students}
                    schoolPersonnelDict={this.state.schoolPersonnelDict}
                    IEPGoals={this.props.teacherBaseProps.IEPGoals}
                    IEPDict={this.props.teacherBaseProps.IEPDict}
                    schoolId={this.props.teacherBaseProps.teacher ?
                        this.props.teacherBaseProps.teacher.schoolId : ''}
                    chatNotificationDict={this.props.teacherBaseProps.chatNotificationDict}
                    setCurrentlyViewingChatIdFunc={this.props.teacherBaseProps.setCurrentlyViewingChatIdFunc}
                />
            </div>
        )
    }
}

export default TeacherChatHome
